import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function SingleLadiesProfile() {
  const navigate = useNavigate();
  const { ladiesid: LadiesID } = useParams();
  const [singleladieslisting, setSingleLadiesListingData] = useState(null);
  const [slidergallery, setSliderImages] = useState([]);
  const [consultation_time_for_call, setConsultationTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validIds, setValidIds] = useState([]); // Store valid female user IDs
  const TOKEN = localStorage.getItem("adminToken");

  // Fetch all female user IDs
  const fetchValidIds = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/getfiltereduser`, {
        gender: "female",
      });
      const users = response.data.data || [];
      const ids = users.map((user) => user.id).sort((a, b) => a - b); // Sort IDs numerically
      setValidIds(ids);
    } catch (error) {
      console.error("Error fetching valid IDs:", error);
    }
  };

  // Fetch profile data
  const fetchSingleLadiesData = async (userId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/getfiltereduser`, {
        id: userId,
        gender: "female",
      });
      const userData = response.data.data[0];
      if (userData) {
        setSingleLadiesListingData(userData);
      } else {
        setError("Profile not found");
        setSingleLadiesListingData(null);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setError("Failed to load profile");
      setSingleLadiesListingData(null);
    } finally {
      setLoading(false);
    }
  };

  // Fetch gallery images
  const getGalleryImages = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/gallery/getbyid/${LadiesID}`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      });
      setSliderImages(response.data.data || []);
    } catch (error) {
      console.error("Error fetching gallery images:", error);
      setSliderImages([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when component mounts or LadiesID changes
  useEffect(() => {
    fetchValidIds(); // Fetch valid IDs on mount
    setSliderImages([]); // Clear previous images
    fetchSingleLadiesData(LadiesID);
    getGalleryImages();
  }, [LadiesID]);

  // Calculate age
  const calculate_age = (dob1) => {
    if (!dob1) return "N/A";
    const today = new Date();
    const birthDate = new Date(dob1);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Convert centimeters to feet and inches
  const convertToFeetAndInches = (centimeters) => {
    if (!centimeters) return "N/A";
    const totalInches = centimeters / 2.54;
    const feet = Math.floor(totalInches / 12);
    const remainingInches = Math.round(totalInches % 12);
    return `${feet} feet ${remainingInches} inches`;
  };

  // Zoom integration
  const client = ZoomMtgEmbedded.createClient();
  const authEndpoint = "https://zoomsdk-sign-generator-express.onrender.com/";
  const sdkKey = "8SN3hNZ8RHmEo_hhBvPpFA";
  const meetingNumber = "7677432145";
  const passWord = "6Qm3Hq";
  const role = 0;
  const userName = "gorank";
  const userEmail = "gws.gorank@gmail.com";
  const registrantToken = "";
  const zakToken = "";
  const video_calluserID = localStorage.getItem("userId");
  const AUTHTOKEN = localStorage.getItem("adminToken");

  const getSignature = async (selected_ladies_id, e) => {
    if (e) e.preventDefault();
    const lid = `%23FCW_${selected_ladies_id}`;
    try {
      const checkExistingResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/svconsultation/checkexisting/?user_id=${video_calluserID}&ladies_id=${lid}`,
        { headers: { Authorization: `Bearer ${AUTHTOKEN}` } }
      );
      if (checkExistingResponse.data.status === 1) {
        setConsultationTime(checkExistingResponse.data.data.consultation_time);
        const authResponse = await fetch(authEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ meetingNumber, role, duration: "1" }),
        });
        if (!authResponse.ok) throw new Error(`HTTP error! Status: ${authResponse.status}`);
        const authData = await authResponse.json();
        startMeeting(authData.signature);
      } else {
        navigate("/videochatform");
      }
    } catch (error) {
      console.error("Error in getSignature:", error);
      if (error.response?.data.status === 0) {
        navigate("/videochatform");
      }
    }
  };

  const startMeeting = (signature) => {
    const meetingSDKElement = document.getElementById("meetingSDKElement");
    client
      .init({ zoomAppRoot: meetingSDKElement, language: "en-US", patchJsMedia: true })
      .then(() => {
        client
          .join({
            signature,
            sdkKey,
            meetingNumber,
            password: passWord,
            userName,
            userEmail,
            tk: registrantToken,
            zak: zakToken,
          })
          .then(() => {
            console.log("Joined successfully");
            setTimeout(() => endZoomMeeting(), consultation_time_for_call * 60 * 1000);
          })
          .catch((error) => console.error("Error joining meeting:", error));
      })
      .catch((error) => console.error("Error initializing meeting:", error));
  };

  const endZoomMeeting = () => {
    navigate("/VideoChatForm");
  };

  // Handle gift navigation
  const handelgift = (ladiesId) => {
    localStorage.setItem("ladiesId", ladiesId);
    navigate(`/giftcategory/${ladiesId}`);
  };

  // Handle favorite profile
  const handleFavProfile = async (ladiesID) => {
    const userID = localStorage.getItem("userId");
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/favorite/managefavorite`,
        { user_id: userID, ladies_user_id: ladiesID },
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      fetchSingleLadiesData(ladiesID); // Refresh profile data
    } catch (error) {
      console.error("Error managing favorite:", error);
    }
  };

  // Get previous and next valid IDs
  const getNavigationIds = () => {
    const currentIndex = validIds.indexOf(parseInt(LadiesID, 10));
    const prevId = currentIndex > 0 ? validIds[currentIndex - 1] : null;
    const nextId = currentIndex < validIds.length - 1 ? validIds[currentIndex + 1] : null;
    return { prevId, nextId };
  };

  const { prevId, nextId } = getNavigationIds();

  return (
    <>
      <section className="page-info-sec">
        <div className="bg-fixed" style={{ backgroundImage: "url('./img/inner_banner.png')" }}></div>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <div className="page-info-block">
                <h1>{singleladieslisting?.fname || "Profile"}</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                <p className="page_nav">
                  <a href="/">Home</a>
                  <span className="mx-2">/</span>
                  <a href="#" className="currentPage">Profile</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="profile-sec secpd70">
        <div className="container" id="meetingSDKElement">
          {loading && <p>Loading...</p>}
          {error && <p className="text-danger">{error}</p>}
          {!loading && !error && singleladieslisting && (
            <div className="row">
              <div className="col-md-12">
                {slidergallery.length > 0 ? (
                  <div className="find-woman-slider-wrap">
                    <OwlCarousel
                      className="owl-theme"
                      items={1}
                      dots
                      loop
                      margin={10}
                      autoplay={false}
                      key={`carousel_${LadiesID}`}
                    >
                      {slidergallery.map((gallerydata, index) => (
                        <div className="item" key={`${LadiesID}_${index}`}>
                          <div className="user-img-box single-ladies-section">
                            <img
                              src={`${process.env.REACT_APP_API_URL}/${gallerydata.image}`}
                              alt={`${singleladieslisting.fname}'s photo`}
                            />
                          </div>
                        </div>
                      ))}
                    </OwlCarousel>
                  </div>
                ) : (
                  <p>No images available</p>
                )}
              </div>
              <div className="col-md-12 mt-4">
                <div className="text-center">
                  <h2 className="title-30">
                    {singleladieslisting.fname} {singleladieslisting.lname}{" "}
                    <span className="text-black-50">({calculate_age(singleladieslisting.dob)})</span>
                  </h2>
                </div>
              </div>
              <div className="col-md-5 mt-3">
                <p className="fs-6 mb-3"><strong>Profile Number:</strong> #FCW_{singleladieslisting.id}</p>
                <p className="fs-6 mb-3"><strong>Location:</strong> {singleladieslisting.address || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>Weight:</strong> {singleladieslisting.weight || "N/A"}kg</p>
                <p className="fs-6 mb-3">
                  <strong>Height:</strong> {singleladieslisting.height || "N/A"} cm (
                  {convertToFeetAndInches(singleladieslisting.height)})
                </p>
                <p className="fs-6 mb-3"><strong>Eye Color:</strong> {singleladieslisting.eyecolor || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>Hair Color:</strong> {singleladieslisting.haircolor || "N/A"}</p>
              </div>
              <div className="col-md-7 mt-3">
                <p className="fs-6 mb-3"><strong>Do you have children? If so, what are their ages?</strong></p>
                <p className="fs-6 mb-3">{singleladieslisting.children_ages || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>What is your occupation or profession?</strong></p>
                <p className="fs-6 mb-3">{singleladieslisting.occupation || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>What are your favorite hobbies or activities?</strong></p>
                <p className="fs-6 mb-3">{singleladieslisting.hobbies || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>How would you describe your personality or characteristics?</strong></p>
                <p className="fs-6 mb-3">{singleladieslisting.personality || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>What type of man do you wish to date or marry?</strong></p>
                <p className="fs-6 mb-3">{singleladieslisting.person_to_marry || "N/A"}</p>
                <p className="fs-6 mb-3"><strong>Where do you see yourself in the future with the right man?</strong></p>
                <p className="fs-6 mb-3">{singleladieslisting.yourself_in_future || "N/A"}</p>
              </div>
              <div className="col-md-12 mt-4">
                <div className="btns-wrap justify-content-center">
                  <a
                    href="/VideoChatForm"
                    className="btn-1 m-0 btn-md"
                    onClick={(e) => getSignature(singleladieslisting.id, e)}
                  >
                    Video chat with Her
                  </a>
                  <a
                    href="#"
                    className="outline-btn-1 m-0 btn-md"
                    onClick={() => handleFavProfile(singleladieslisting.id)}
                  >
                    <i
                      className={`fa fa-heart${singleladieslisting.favorites?.length > 0 &&
                        singleladieslisting.favorites[0].total_favorite != 0
                        ? " redHeartIcon"
                        : ""
                        }`}
                    >
                      {singleladieslisting.favorites?.length > 0 &&
                        singleladieslisting.favorites[0].total_favorite != 0
                        ? singleladieslisting.favorites[0].total_favorite
                        : ""}
                    </i>
                  </a>
                  <a
                    onClick={() => handelgift(singleladieslisting.id)}
                    className="btn-1 m-0 btn-md send_gift_btn"
                  >
                    Send Gift to Her
                  </a>
                </div>
              </div>
              <div className="col-md-12">
                <div className="next-prev-profile justify-content-between flex-wrap">
                  {prevId ? (
                    <Link
                      to={`/singleLadiesProfile/${prevId}`}
                      className="outline-btn-1 btn-md"
                      onClick={() => setSliderImages([])}
                    >
                      Previous profile
                    </Link>
                  ) : (
                    <span className="outline-btn-1 btn-md disabled">Previous profile</span>
                  )}
                  {nextId ? (
                    <Link
                      to={`/singleLadiesProfile/${nextId}`}
                      className="outline-btn-1 btn-md"
                      onClick={() => setSliderImages([])}
                    >
                      Next profile
                    </Link>
                  ) : (
                    <span className="outline-btn-1 btn-md disabled">Next profile</span>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default SingleLadiesProfile;
